import { render, staticRenderFns } from "./DesignProduct.vue?vue&type=template&id=680542b3&"
import script from "./DesignProduct.vue?vue&type=script&lang=js&"
export * from "./DesignProduct.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports